import React, { useEffect, useRef, useState } from "react";
import TimelineTimeRangePopup from "../../TimeLine/HazardIncidentsTimeLine+/TimelineTimeRangePopup";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Feature } from "ol";
import { fromLonLat } from "ol/proj";
import { Geometry, Point } from "ol/geom";
import Overlay from "ol/Overlay.js";
import ReportIncidentPopUp from "./ReportIncidentPopUp";
import ReactDOM from "react-dom";
import Style from "ol/style/Style";
import Icon from "ol/style/Icon";
import { map } from "../../mainLayer/MainLayer";
import { LocationMarkerPopup } from "../../mainLayer/MainWindow";
import { Coordinate } from "ol/coordinate";
import styles from "../../initial/layersPopup/Menu.module.css";
import { format, parse } from "date-fns";
import { getLayerName } from "../../TimeLine/MainTimeLineVisible";
import AddHzLayer from "./AddHzLayer";
import {
  layerButtonValue,
  openWindowsMapRiver,
  riverMap,
} from "../../riverSensors/RiverSensors";
import { useHzContext } from "../../provider/HzProvider";
import { useAllWeatherContext } from "../../provider/AllWeatherProvider";
import {
  airQualityMap,
  openWindowsAirQualityMap,
} from "../airQuality/airQuality";
import {
  EWSSidebarMap,
  openEwsWindowsMap,
} from "../earlyWarning/ShowEarlyWarning";
import { openWindowsRainfallMap, rainfallMap } from "../rainfall/Rainfall";

export interface hzIncidents {
  w_id: string;
  lat: number;
  lon: number;
  adm4_en: string;
  bwater_level: string;
  end_time: string;
  hwater_level: string;
  img_url: string;
  imp_communication: string;
  imp_electricity: string;
  imp_house: string;
  imp_human: string;
  imp_response: string;
  imp_roadblock: string;
  imp_roaddamage: string;
  imp_water: string;
  impdes_communication: string;
  impdes_electricity: string;
  impdes_house: string;
  impdes_human: string;
  impdes_roadblock: string;
  impdes_roaddamage: string;
  impdes_water: string;
  issued_time: string;
  occurance_date: string;
  observed_date: string;
  tp_number: string;
  w_desc: string;
  w_name: string;
  w_type: string;
  w_status: string;
  adm3_en: string;
}

export interface incidentsSidebar {
  sensorId: string | null;
  coordinates: Coordinate | null;
  adm4_en: string | null;
  bwater_level: string | null;
  end_time: string | null;
  hwater_level: string | null;
  img_url: string | null;
  imp_communication: string | null;
  imp_electricity: string | null;
  imp_house: string | null;
  imp_human: string | null;
  imp_response: string | null;
  imp_roadblock: string | null;
  imp_roaddamage: string | null;
  imp_water: string | null;
  impdes_communication: string | null;
  impdes_electricity: string | null;
  impdes_house: string | null;
  impdes_human: string | null;
  impdes_roadblock: string | null;
  impdes_roaddamage: string | null;
  impdes_water: string | null;
  issued_time: string | null;
  occurance_date: string | null;
  observed_date: string | null;
  tp_number: string | null;
  w_desc: string | null;
  w_name: string | null;
  w_type: string | null;
}

export const openWindowsHzMap = new Map<string, string>();
const typeAndDuration = new Map<string, string>();
let openHazardTypeMap: Map<string, boolean> = new Map();
let openHZTypeMap: Map<string, boolean> = new Map();
let HazardTypeDurationMap: Map<string, string> = new Map();
let clickedHzIncident: boolean = false;
let hzAllIncidents: hzIncidents[] = [];

export const HzSidebarMap: Map<string, incidentsSidebar> = new Map();

interface ReportIncidentsProps {
  passStartDurationForm: (from: string) => void;
  passFromDurationTo: (to: string) => void;
  endTime: string;
  playTimer: boolean;
  showTimeRangeNotification: (show: boolean) => void;
  id: number;
  index: number;
  title: string;
  dragItemRef: any;
  dragOverRef: any;
  handleSort: any;
  passClickedHzIncidentMapValue: (clicked: boolean) => void;
  menuOpen: boolean;
  timeLineHour: string;
  timeLineDate: string;
  sensorType: (value: string) => void;
  openModular: (value: string) => void;
  renderHz: (value: boolean) => void;
}

const IncidentsMenuDropDown: React.FC<ReportIncidentsProps> = ({
  passStartDurationForm,
  passFromDurationTo,
  endTime,
  playTimer,
  showTimeRangeNotification,
  id,
  index,
  title,
  dragItemRef,
  dragOverRef,
  handleSort,
  passClickedHzIncidentMapValue,
  menuOpen,
  timeLineHour,
  timeLineDate,
  sensorType,
  openModular,
  renderHz,
}: ReportIncidentsProps) => {
  const [selectedDuration, setSelectedDuration] = useState<string>("");
  const [nonExitDuration, setNonExitDuration] = useState<string>("");
  const [incidentType, setIncidentType] = useState<string>("");
  const [hzIncidents, setHZincidents] = useState<hzIncidents[]>([]);
  // const [hzAllIncidents, setAllHZincidents] = useState<hzIncidents[]>([]);
  const [isClicked, setIsClicked] = useState<boolean>(true);
  const [isSameDuration, setIsSameDuration] = useState<boolean>(false);
  const [currentLayer, setCurrentLayer] = useState<
    VectorLayer<VectorSource<Feature<Geometry>>>
  >(
    new VectorLayer({
      source: new VectorSource(),
    })
  );
  const {
    HzOpenSidebarMap,
    setHzOpenSidebarMap,
    removeFromHzOpenSidebarMap,
    clearHzOpenSidebarMap,
  } = useHzContext();
  const [incidentMap, setIncidentMap] = useState<Record<string, string>>({});
  const [showTimeRange, setShowTimeRange] = useState<boolean>(false);
  const [selectTimeRange, setSelectTimeRange] = useState<boolean>(false);
  const [initialLoad, setInitialLoad] = useState<boolean>(false);
  const [clickedPopup, setClickedPopup] = useState<boolean>(false);
  const [_, setRender] = useState(false);
  const { setMarker } = useAllWeatherContext();

  const toggleSensorVisibility = () => {
    setRender((prevRender) => {
      const newRender = !prevRender;
      setTimeout(() => {
        renderHz(newRender);
      }, 0);
      // renderHz(newRender);
      return newRender;
    });
  };

  const sensorMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/landslide_icon.png",
      scale: 0.3,
    }),
  });

  const floodMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/flood_icon.png",
      scale: 0.2,
    }),
  });

  const lightningMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/lightning_icon.png",
      scale: 0.2,
    }),
  });

  const cycloneMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/cyclone_icon.png",
      scale: 0.2,
    }),
  });

  const heavyRainMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/iconm_heavyrain.png",
      scale: 0.2,
    }),
  });

  const explosionMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/explosion_icon.png",
      scale: 0.2,
    }),
  });

  const nuclearMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/nuclear_icon.png",
      scale: 0.2,
    }),
  });

  const virusMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/virus_icon.png",
      scale: 0.2,
    }),
  });

  const earthMarker = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/earth_icon.png",
      scale: 0.2,
    }),
  });

  const sensorEmpty = new Style({
    image: new Icon({
      anchor: [0.5, 1],
      src: "assets/tra3.png",
      scale: 0.1,
      opacity: 0.1,
    }),
  });

  const animationHzMap = new Map([
    ["ILSW", "assets/landslide_icong.gif"],
    ["IFLW", "assets/flood_icong.gif"],
    ["ITHS", "assets/lightning_icong.gif"],
    ["HWN", "assets/lightning_icong.gif"],
  ]);

  const iconHzMap = new Map([
    ["ILSW", sensorMarker],
    ["IFLW", floodMarker],
    ["ITHS", lightningMarker],
    ["HWN", cycloneMarker],
    ["LIG", lightningMarker],
    ["ILSS", sensorMarker],
    ["ITSM", cycloneMarker],
    ["HRW", heavyRainMarker],
    ["IFFIR", explosionMarker],
    ["EXPL", explosionMarker],
    ["IFIR", explosionMarker],
    ["NUCL", nuclearMarker],
    ["BIOL", virusMarker],
    ["IEQA", earthMarker],
  ]);

  const adjustMarkerSize = (zoom: number): void => {
    const scaleFactor = zoom / 10; // Example: scale factor based on zoom level

    iconHzMap.forEach((style) => {
      const icon = style.getImage();
      if (icon instanceof Icon && icon !== null) {
        icon.setScale(0.4 * scaleFactor); // Adjust scale based on zoom level
      }
    });
  };

  map.on("moveend", () => {
    const zoom = map.getView().getZoom();
    if (zoom !== undefined) {
      adjustMarkerSize(zoom);
    }
  });

  let currentZoom = map.getView().getZoom();

  map.getView().on("change:resolution", function () {
    const newZoom = map.getView().getZoom();

    if (typeof newZoom === "number" && newZoom !== currentZoom) {
      currentZoom = newZoom;

      map.getOverlays().forEach(function (overlay) {
        const element = overlay.getElement();
        if (element && element.tagName === "IMG") {
          const baseSize = 40;
          const scaleFactor = newZoom / 10;
          const newSize = baseSize * scaleFactor;
          element.style.width = `${newSize}px`;
          element.style.height = `${newSize}px`;
        }
      });
    }
  });

  const removeOverlay = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const onClickHandler = (duration: string): void => {
    if (duration === "custom date") {
      setSelectTimeRange(true);
      fetchData("custom date");
      //     openHazardTypeMap.forEach((value, key) => {
      //    if (value === true && incidentType === key) {
      //     if (isEyeOpen) {
      //      setIsEyeOpen(false);
      //    }
      //    }
      //  });
    } else if (duration === "last 2 weeks") {
      //  passTimrangeValue(duration);
      setSelectTimeRange(false);
      fetchData("last 2 weeks");
      openHazardTypeMap.forEach((value, key) => {
        if (value === true && incidentType === key) {
          if (isEyeOpen) {
            setIsEyeOpen(false);
          }
        }
      });
    } else if (duration === "last 1 month") {
      //  passTimrangeValue(duration);
      setSelectTimeRange(false);
      fetchData("last 1 month");
      // if (isEyeOpen) {
      //   setIsEyeOpen(false);
      // }
    } else if (duration === "last 6 months") {
      // passTimrangeValue(duration);
      setSelectTimeRange(false);
      fetchData("last 6 months");
      // if (isEyeOpen) {
      //   setIsEyeOpen(false);
      // }
    } else if (duration === "Clear") {
      setIsClicked(true);
      setIsSameDuration(false);
      setSelectTimeRange(false);
      fetchData("Clear");
      removeOverlay("hz");
      setTimeout(() => {
        removeOverlay("hz");
      }, 500);
    }

    if (selectedDuration === duration) {
      setSelectTimeRange(false);
      setIsSameDuration(false);
      setIsClicked(false);
    } else if (selectedDuration === "") {
      setIsClicked((prevState) => !prevState);
      setIsSameDuration(false);
    } else if (selectedDuration !== duration && selectedDuration !== "") {
      setIsClicked((prevState) => !prevState);
      //-------------------if getting same duration-----------------------------------------------------
      setIsSameDuration((prevState) => !prevState);
    }

    if (duration !== "Clear") {
      setNonExitDuration(duration);
    }
  };

  const fetchData = async (time: string) => {
    try {
      const gisArray = {
        arealist: process.env.REACT_APP_GIS_ARRAY_HZ
          ? process.env.REACT_APP_GIS_ARRAY_HZ.split(",")
          : [],
      };

      const REPORTED_INCIDENTS_URL =
        process.env.REACT_APP_REPORTED_INCIDENTS_URL;
      const REPORTED_INCIDENTS_TWO_WEEK =
        process.env.REACT_APP_REPORTED_INCIDENTS_TWO_WEEK_URL;
      const REPORTED_INCIDENTS_ONE_MONTH =
        process.env.REACT_APP_REPORTED_INCIDENTS_ONE_MONTH_URL;
      const REPORTED_INCIDENTS_SIX_MONTHS =
        process.env.REACT_APP_REPORTED_INCIDENTS_SIX_MONTHS_URL;

      const queryString = Object.entries(gisArray)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(
              JSON.stringify(value)
            )}`
        )
        .join("&");

      if (!hzAllIncidents || hzAllIncidents.length === 0) {
        let urlAll = `${REPORTED_INCIDENTS_URL}${queryString}`;

        const responseAll = await fetch(urlAll);
        const responseDataAll = await responseAll.json();
        if (Array.isArray(responseDataAll)) {
          const data: hzIncidents[] = responseDataAll;
          // setAllHZincidents(data);
          hzAllIncidents = data;
          const incidentMapping = data.reduce((acc, incident) => {
            acc[incident.w_id] = incident.end_time;
            return acc;
          }, {} as Record<string, string>);
          setIncidentMap(incidentMapping);
        }
      }

      let url = "";

      if (time === "last 2 weeks") {
        url = `${REPORTED_INCIDENTS_TWO_WEEK}${queryString}`;
      } else if (time === "last 1 month") {
        url = `${REPORTED_INCIDENTS_ONE_MONTH}${queryString}`;
      } else if (time === "last 6 months") {
        url = `${REPORTED_INCIDENTS_SIX_MONTHS}${queryString}`;
      } else if (time === "custom date") {
        url = `${REPORTED_INCIDENTS_URL}${queryString}`;
      } else if (time === "Clear") {
        url = `${REPORTED_INCIDENTS_TWO_WEEK}${queryString}`;
      }

      const response = await fetch(url);
      const responseData = await response.json();

      if (Array.isArray(responseData)) {
        const data: hzIncidents[] = responseData;
        if (time === "Clear") {
          setHZincidents(filterClearType(data));
        } else {
          setHZincidents(filterByHazardType(data));
        }

        //  setHZincidents(data);
        createOpenPopupmap(data);
        setSelectedDuration(time);
      } else {
        console.error("Invalid response data format:", responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setInitialLoad(true);
  };

  const incidentTypeMap = new Map([
    ["Landslides", "ILSW"],
    ["Flood", "IFLW"],
    ["Heavy Rain & Thunderstorm", "ITHS"],
    ["Severe Lightning", "HWN"],
  ]);

  const filterByHazardType = (data: hzIncidents[]): hzIncidents[] => {

    if (incidentType) {
      const mappedType = incidentTypeMap.get(incidentType);

      if (mappedType) {
        return data.filter((incident) => incident.w_type === mappedType);
      }
    }
    return data;
  };

  // const filterClearType = (data: hzIncidents[]): hzIncidents[] => {
  //   openHazardTypeMap.forEach((value, key) => {
  //     console.log(`Key: ${key}, Value: ${value}`);
  //   });
  //   if (incidentType) {
  //     const mappedType = incidentTypeMap.get(incidentType);
  //     if (mappedType) {
  //       return data.filter((incident) => incident.w_type !== mappedType);
  //     }
  //   }
  //   return data;
  // };

  const filterClearType = (data: hzIncidents[]): hzIncidents[] => {
    // trueKeySet.clear();
    // openHazardTypeMap.forEach((value, key) => {
    //   console.log(`Key: ${key}, Value: ${value}`);
    //   if (value === true) {
    //     const mappedType = incidentTypeMap.get(key);
    //     if (mappedType) {
    //     trueKeySet.add(mappedType)
    //     }
    //   }
    // });

    return [];
  };

  const createOpenPopupmap = (data: hzIncidents[]) => {
    data.forEach((incident) => {
      openWindowsHzMap.set(incident.w_id, "close");
    });
  };

  useEffect(() => {}, [initialLoad]);

  useEffect(() => {}, [timeLineDate]);

  useEffect(() => {}, [timeLineHour]);

  let startDate = "2024-05-30";

  useEffect(() => {
    if (hzIncidents.length > 0) {
      if (timeLineDate && incidentMap) {
        // -----------------------------------create for time----------------
        // openHZTypeMap.forEach((value, key) => {
        //   console.log(`Key: ${key}, Value: ${value}`);
        // });
        // const filteredIncidents = hzAllIncidents.filter(
        //   (incident) =>
        //     new Date(incident.end_time) >= new Date(startDate) &&
        //     new Date(incident.end_time) <= new Date(timeLineDate) &&
        //     openHZTypeMap.get(incident.w_type) === true
        // );
        // createMapWithMarkers(filteredIncidents);

        createMapWithMarkers(hzIncidents);
      } else {
        createMapWithMarkers(hzIncidents);
      }
    } else if (
      hzIncidents.length === 0 &&
      incidentType !== "" &&
      initialLoad === true
    ) {
      emptyMarkers(hzIncidents);
    }
  }, [hzIncidents, incidentMap, timeLineDate]);

  const emptyMarkers = async (flteredIncidents: hzIncidents[]) => {
    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });
    setCurrentLayer(vectorLayer);

    if (currentLayer) {
      map.removeLayer(currentLayer);
    }

    if (playTimer === true) {
      if (selectedDuration !== "" && selectedDuration !== "Clear") {
        setIsClicked((prevState) => !prevState);
      } else if (selectedDuration !== "" && selectedDuration === "Clear") {
        setIsClicked(true);
      }
    } else if (playTimer === false) {
      if (selectedDuration !== "" && selectedDuration !== "Clear") {
        setIsClicked(false);
      } else if (selectedDuration !== "" && selectedDuration === "Clear") {
        setIsClicked(true);
      }
    }
    setIsSameDuration(false);
    setInitialLoad(false);
    getLayerName("hzIncidents", true);
  };

  const createMapWithMarkers = async (flteredIncidents: hzIncidents[]) => {
    if (currentLayer) {
      map.removeLayer(currentLayer);
    }

    if (playTimer === true) {
      if (selectedDuration !== "" && selectedDuration !== "Clear") {
        setIsClicked((prevState) => !prevState);
      } else if (selectedDuration !== "" && selectedDuration === "Clear") {
        setIsClicked(true);
      }
    } else if (playTimer === false) {
      if (selectedDuration !== "" && selectedDuration !== "Clear") {
        setIsClicked(false);
      } else if (selectedDuration !== "" && selectedDuration === "Clear") {
        setIsClicked(true);
      }
    }
    setIsSameDuration(false);

    const vectorSource = new VectorSource();
    const vectorLayer = new VectorLayer({
      source: vectorSource,
    });

    const sensorLevels = await Promise.all(
      flteredIncidents.map(async (marker) => {
        return { marker };
      })
    );

    const newFeatures = sensorLevels.map(({ marker }) => {
      const point = new Point(fromLonLat([marker.lon, marker.lat]));

      const feature = new Feature({
        geometry: point,
        id: marker.w_id,
        adm4_en: marker.adm4_en,
        bwater_level: marker.bwater_level,
        end_time: marker.end_time,
        hwater_level: marker.hwater_level,
        img_url: marker.img_url,
        imp_communication: marker.imp_communication,
        imp_electricity: marker.imp_electricity,
        imp_house: marker.imp_house,
        imp_human: marker.imp_human,
        imp_response: marker.imp_response,
        imp_roadblock: marker.imp_roadblock,
        imp_roaddamage: marker.imp_roaddamage,
        imp_water: marker.imp_water,
        impdes_communication: marker.impdes_communication,
        impdes_electricity: marker.impdes_electricity,
        impdes_house: marker.impdes_house,
        impdes_human: marker.impdes_human,
        impdes_roadblock: marker.impdes_roadblock,
        impdes_roaddamage: marker.impdes_roaddamage,
        impdes_water: marker.impdes_water,
        issued_time: marker.issued_time,
        occurance_date: marker.occurance_date,
        observed_date: marker.observed_date,
        tp_number: marker.tp_number,
        w_desc: marker.w_desc,
        w_name: marker.w_name,
        w_type: marker.w_type,
      });

      const issuedTime = new Date(marker.issued_time);
      const oneDayLater = new Date(issuedTime); // Create a new Date object to avoid modifying the original
      oneDayLater.setDate(oneDayLater.getDate() + 1);

      const cutoffDate = new Date("2024-05-20");
      const today = new Date();

      let style;
      if (oneDayLater > today) {
        if (marker.w_type) {
          const gifLink = animationHzMap.get(marker.w_type.toString());
          if (gifLink) {
            const gifElement = document.createElement("img");
            gifElement.src = gifLink;
            gifElement.style.width = "30px";
            const coordinates = point.getCoordinates();
            const overlay = new Overlay({
              id: marker.w_type,
              position: coordinates,
              positioning: "center-center",
              element: gifElement,
              stopEvent: false,
            });
            map.addOverlay(overlay);
            style = sensorEmpty;
          }
        }
      } else if (oneDayLater <= today) {
        if (marker.w_type !== null) {
          if (marker.w_type) {
            style = iconHzMap.get(marker.w_type);
          }
          if (!style) {
            style = sensorMarker;
          }
        } else {
          style = sensorMarker;
        }
      }
      feature.setStyle(style);
      return feature;
    });

    vectorSource.addFeatures(newFeatures);
    setCurrentLayer(vectorLayer);

    map.on("click", (evt) => {
      const feature = map.forEachFeatureAtPixel(evt.pixel, (feature) => {
        return feature;
      });
      if (feature) {
        setMarker("clickMarker");
      }
      const value = feature
        ? openWindowsHzMap.get(feature.get("id"))
        : undefined;

      if (feature && value === "close") {
        const geometry = feature.getGeometry() as Point;
        const coordinates = geometry.getCoordinates();
        const sensorId = feature.get("id");
        const adm4_en = feature.get("adm4_en");
        const bwater_level = feature.get("bwater_level");
        const end_time = feature.get("end_time");
        const hwater_level = feature.get("hwater_level");
        const img_url = feature.get("img_url");
        const imp_communication = feature.get("imp_communication");
        const imp_electricity = feature.get("imp_electricity");
        const imp_house = feature.get("imp_house");
        const imp_human = feature.get("imp_human");
        const imp_response = feature.get("imp_response");
        const imp_roadblock = feature.get("imp_roadblock");
        const imp_roaddamage = feature.get("imp_roaddamage");
        const imp_water = feature.get("imp_water");
        const impdes_communication = feature.get("impdes_communication");
        const impdes_electricity = feature.get("impdes_electricity");
        const impdes_house = feature.get("impdes_house");
        const impdes_human = feature.get("impdes_human");
        const impdes_roadblock = feature.get("impdes_roadblock");
        const impdes_roaddamage = feature.get("impdes_roaddamage");
        const impdes_water = feature.get("impdes_water");
        const issued_time = feature.get("issued_time");
        const occurance_date = feature.get("occurance_date");
        const observed_date = feature.get("observed_date");
        const tp_number = feature.get("tp_number");
        const w_desc = feature.get("w_desc");
        const w_name = feature.get("w_name");
        const w_type = feature.get("w_type");

        if (w_desc) {
          openWindowsHzMap.set(sensorId, "open");
          LocationMarkerPopup("hzIncidents");
          showPopup(
            sensorId,
            coordinates,
            adm4_en,
            bwater_level,
            end_time,
            hwater_level,
            img_url,
            imp_communication,
            imp_electricity,
            imp_house,
            imp_human,
            imp_response,
            imp_roadblock,
            imp_roaddamage,
            imp_water,
            impdes_communication,
            impdes_electricity,
            impdes_house,
            impdes_human,
            impdes_roadblock,
            impdes_roaddamage,
            impdes_water,
            issued_time,
            occurance_date,
            observed_date,
            tp_number,
            w_desc,
            w_name,
            w_type
          );
          if (layerButtonValue === "hawk eye") {
            const entries = Array.from(HzSidebarMap.values());
            const lastEntryIndex = entries.length - 1;
            entries.forEach((details, index) => {
              const { coordinates, sensorId } = details;
              if (coordinates) {
                removeAnimation(sensorId!);
                if (index === lastEntryIndex) {
                  // Handle last entry
                  addOverlayClickItemLast(sensorId!, coordinates);
                } else {
                  // Handle all other entries
                  addOverlayClickItem(sensorId!, coordinates);
                }
              }
            });
          }
        }
      }
      setTimeout(() => {
        setMarker("notClickMarker");
      }, 500);
    });

    setInitialLoad(false);

    // console.log("--------isClicked-----here--------" + selectTime);
    AddHzLayer(vectorLayer, isClicked, "hzIncidents");
  };

  useEffect(() => {
    const entries = Array.from(HzOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeAnimation(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
  }, [HzOpenSidebarMap.size]);

  const removeAnimation = (key: string) => {
    const overlays = map.getOverlays().getArray();
    const overlaysToRemove = overlays.filter(
      (overlay) => overlay.getId() === key
    );
    overlaysToRemove.forEach((overlay) => {
      map.removeOverlay(overlay);
    });
  };

  const addOverlayClickItem = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "location-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "location-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  const addOverlayClickItemLast = (id: string, coordinates: Coordinate) => {
    const markerElement = document.createElement("div");
    markerElement.className = "locationlast-dot animate";

    const ringElement = document.createElement("div");
    ringElement.className = "locationlast-dot-ring";

    markerElement.appendChild(ringElement);
    const overlay = new Overlay({
      id: id,
      position: coordinates,
      positioning: "center-center",
      element: markerElement,
      stopEvent: false,
    });
    map.addOverlay(overlay);
  };

  useEffect(() => {
    if (selectedDuration === "Clear") {
      createMapWithMarkers(hzIncidents);
    }
  }, [selectedDuration]);

  useEffect(() => {
    if (isSameDuration) {
      setIsClicked(false);
    }
  }, [selectedDuration, nonExitDuration, incidentType, isSameDuration]);

  useEffect(() => {
    if (showTimeRange) {
      setShowTimeRange(false);
    }
  }, [showTimeRange]);

  const handleClose = (incidentId: string) => {
    openWindowsHzMap.set(incidentId, "close");
    removeFromHzOpenSidebarMap(incidentId);
    removeAnimation(incidentId!);
    if (HzSidebarMap.has(incidentId)) {
      HzSidebarMap.delete(incidentId);
    }
    const entries = Array.from(HzOpenSidebarMap.values());
    const lastEntryIndex = entries.length - 1;
    entries.forEach((details, index) => {
      const { coordinates, sensorId } = details;
      if (coordinates) {
        removeOverlay(sensorId!);
        if (index === lastEntryIndex) {
          // Handle last entry
          addOverlayClickItemLast(sensorId!, coordinates);
        } else {
          // Handle all other entries
          addOverlayClickItem(sensorId!, coordinates);
        }
      }
    });
    if (layerButtonValue === "hawk eye") {
      const entries = Array.from(HzSidebarMap.values());
      const lastEntryIndex = entries.length - 1;
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          if (index === lastEntryIndex) {
            // Handle last entry
            addOverlayClickItemLast(sensorId!, coordinates);
          } else {
            // Handle all other entries
            addOverlayClickItem(sensorId!, coordinates);
          }
        }
      });
    }
  };

  useEffect(() => {
    const entries = Array.from(HzOpenSidebarMap.values());
  }, [HzOpenSidebarMap.values()]);

  const showPopup = (
    sensorId: string | null,
    coordinates: Coordinate | null,
    adm4_en: string | null,
    bwater_level: string | null,
    end_time: string | null,
    hwater_level: string | null,
    img_url: string | null,
    imp_communication: string | null,
    imp_electricity: string | null,
    imp_house: string | null,
    imp_human: string | null,
    imp_response: string | null,
    imp_roadblock: string | null,
    imp_roaddamage: string | null,
    imp_water: string | null,
    impdes_communication: string | null,
    impdes_electricity: string | null,
    impdes_house: string | null,
    impdes_human: string | null,
    impdes_roadblock: string | null,
    impdes_roaddamage: string | null,
    impdes_water: string | null,
    issued_time: string | null,
    occurance_date: string | null,
    observed_date: string | null,
    tp_number: string | null,
    w_desc: string | null,
    w_name: string | null,
    w_type: string | null
  ) => {
    toggleSensorVisibility();
    sensorType("hzLocation");
    if (layerButtonValue === "modular") {
      const entries = Array.from(airQualityMap.values());
      entries.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsAirQualityMap.set(sensorId!, "close");
        }
      });
      const entriesEws = Array.from(EWSSidebarMap.values());
      entriesEws.forEach((details, index) => {
        const { coordinates, active_pcode } = details;
        if (coordinates) {
          removeOverlay(active_pcode!);
          openEwsWindowsMap.set(active_pcode!, "close");
        }
      });
      const entriesriver = Array.from(riverMap.values());
      entriesriver.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsMapRiver.set(sensorId!, "close");
        }
      });
      const entriesRain = Array.from(rainfallMap.values());
      entriesRain.forEach((details, index) => {
        const { coordinates, sensorId } = details;
        if (coordinates) {
          removeOverlay(sensorId!);
          openWindowsRainfallMap.set(sensorId!, "close");
        }
      });
    }
    if (sensorId && coordinates) {
      const popupElement = document.createElement("div");
      if (layerButtonValue === "hawk eye") {
        ReactDOM.render(
          <ReportIncidentPopUp
            incidentId={sensorId}
            adm4_en={adm4_en}
            bwater_level={bwater_level}
            end_time={end_time}
            hwater_level={hwater_level}
            img_url={img_url}
            imp_communication={imp_communication}
            imp_electricity={imp_electricity}
            imp_house={imp_house}
            imp_human={imp_human}
            imp_response={imp_response}
            imp_roadblock={imp_roadblock}
            imp_roaddamage={imp_roaddamage}
            imp_water={imp_water}
            impdes_communication={impdes_communication}
            impdes_electricity={impdes_electricity}
            impdes_house={impdes_house}
            impdes_human={impdes_human}
            impdes_roadblock={impdes_roadblock}
            impdes_roaddamage={impdes_roaddamage}
            impdes_water={impdes_water}
            issued_time={issued_time}
            occurance_date={occurance_date}
            observed_date={observed_date}
            tp_number={tp_number}
            w_desc={w_desc}
            w_name={w_name}
            w_type={w_type}
            onClose={handleClose}
          />,
          popupElement
        );
        const overlay = new Overlay({
          element: popupElement,
          autoPan: {
            animation: {
              duration: 250,
            },
          },
        });
        overlay.setPosition(coordinates);
        map.addOverlay(overlay);
        const newHz: incidentsSidebar = {
          sensorId: sensorId,
          coordinates: coordinates,
          adm4_en: adm4_en,
          bwater_level: bwater_level,
          end_time: end_time,
          hwater_level: hwater_level,
          img_url: img_url,
          imp_communication: imp_communication,
          imp_electricity: imp_electricity,
          imp_house: imp_house,
          imp_human: imp_human,
          imp_response: imp_response,
          imp_roadblock: imp_roadblock,
          imp_roaddamage: imp_roaddamage,
          imp_water: imp_water,
          impdes_communication: impdes_communication,
          impdes_electricity: impdes_electricity,
          impdes_house: impdes_house,
          impdes_human: impdes_human,
          impdes_roadblock: impdes_roadblock,
          impdes_roaddamage: impdes_roaddamage,
          impdes_water: impdes_water,
          issued_time: issued_time,
          occurance_date: occurance_date,
          observed_date: observed_date,
          tp_number: tp_number,
          w_desc: w_desc,
          w_name: w_name,
          w_type: w_type,
        };
        setHzOpenSidebarMap(newHz.sensorId!, newHz);
        HzSidebarMap.set(newHz.sensorId!, newHz);
      } else if (layerButtonValue === "modular") {
        const newHz: incidentsSidebar = {
          sensorId: sensorId,
          coordinates: coordinates,
          adm4_en: adm4_en,
          bwater_level: bwater_level,
          end_time: end_time,
          hwater_level: hwater_level,
          img_url: img_url,
          imp_communication: imp_communication,
          imp_electricity: imp_electricity,
          imp_house: imp_house,
          imp_human: imp_human,
          imp_response: imp_response,
          imp_roadblock: imp_roadblock,
          imp_roaddamage: imp_roaddamage,
          imp_water: imp_water,
          impdes_communication: impdes_communication,
          impdes_electricity: impdes_electricity,
          impdes_house: impdes_house,
          impdes_human: impdes_human,
          impdes_roadblock: impdes_roadblock,
          impdes_roaddamage: impdes_roaddamage,
          impdes_water: impdes_water,
          issued_time: issued_time,
          occurance_date: occurance_date,
          observed_date: observed_date,
          tp_number: tp_number,
          w_desc: w_desc,
          w_name: w_name,
          w_type: w_type,
        };
        openModular("modularOpened");
        HzSidebarMap.set(newHz.sensorId!, newHz);
        setHzOpenSidebarMap(newHz.sensorId!, newHz);
      }
    }
  };

  const [isOpen, setIsOpen] = useState<boolean>(false);
  // Layer visibility status (visible / not visible)
  const [isEyeOpen, setIsEyeOpen] = useState<boolean>(true);
  // Layer visibility status (visible / not visible)
  const [isAllFilterOpen, setIsAllFilterOpen] = useState<boolean>(false);
  const [selectedRadio, setSelectedRadio] = useState<string>("");

  // to clicked button remain clicked
  const openHzType = (type: string, isOpen: boolean) => {
    openHazardTypeMap.set(type, isOpen);
    const mappedType = incidentTypeMap.get(type);

    // If the mappedType exists (i.e., it's not undefined), set the value in openHZTypeMap
    if (mappedType) {
      openHZTypeMap.set(mappedType, isOpen);
    }

    clickedHzIncident = Array.from(openHazardTypeMap.values()).some(
      (value) => value
    );
    // openHazardTypeMap.forEach((value, key) => {
    //   console.log(`Key: ${key}, Value: ${value}`);
    // });

    passClickedHzIncidentMapValue(clickedHzIncident);
  };

  // to clicked type and duration remain when main window relaunch
  const findOpenHazardTypeKeys = () => {
    const openKeys = Array.from(openHazardTypeMap.entries())
      .filter(([key, value]) => value)
      .map(([key]) => key);
    return openKeys;
  };

  useEffect(() => {
    if (
      openHazardTypeMap.size > 0 &&
      clickedPopup === false &&
      menuOpen === true
    ) {
      const openKeys = findOpenHazardTypeKeys();
      if (openKeys.includes(title)) {
        setIsEyeOpen(false);
        setIncidentType(title);
        const value = HazardTypeDurationMap.get(title);

        if (value) {
          setSelectedRadio(value);
          // to marker layers update when reopen
          if (value === "last 2 weeks") {
            onClickHandler("last 2 weeks");
          } else if (value === "on2") {
            onClickHandler("last 1 month");
          } else if (value === "on3") {
            onClickHandler("last 6 months");
          } else if (value === "on4") {
            onClickHandler("custom date");
          }
        } else {
          onClickHandler("last 2 weeks");
        }
      }
    }
  }, [
    openHazardTypeMap,
    title,
    clickedPopup,
    isEyeOpen,
    selectedRadio,
    incidentType,
    menuOpen,
  ]);

  useEffect(() => {
    const mapString = JSON.stringify(Array.from(openHZTypeMap.entries()));

    openHazardTypeMap.forEach((value, key) => {
      if (key === "Landslides" && value === false) {
        const entries = Array.from(HzSidebarMap.values());
        entries.forEach((details) => {
          const { coordinates, sensorId, w_type } = details;
          if (w_type === "ILSW") {
            removeOverlay(sensorId!);
          }
        });
        HzSidebarMap.clear();
        clearHzOpenSidebarMap();
      } else if (key === "Flood" && value === false) {
        const entries = Array.from(HzSidebarMap.values());
        entries.forEach((details) => {
          const { coordinates, sensorId, w_type } = details;
          if (w_type === "IFLW") {
            removeOverlay(sensorId!);
          }
        });
        HzSidebarMap.clear();
        clearHzOpenSidebarMap();
      } else if (key === "Heavy Rain & Thunderstorm" && value === false) {
        const entries = Array.from(HzSidebarMap.values());
        entries.forEach((details) => {
          const { coordinates, sensorId, w_type } = details;
          if (w_type === "ITHS") {
            removeOverlay(sensorId!);
          }
        });
        // HzSidebarMap.clear();
        // clearHzOpenSidebarMap();
      }
    });
  }, [JSON.stringify(Array.from(openHZTypeMap.entries()))]);

  // Layer drop down button funtion
  const DropDownMenu = (ttl: string) => {
    setClickedPopup(true);
    if (isOpen === true) {
      setIsOpen(false);
      setIsAllFilterOpen(false);
    } else {
      setIsOpen(true);
      //to check open hazardtypes
      openHzType(ttl, true);
    }
    setIncidentType(ttl);
    //initialy if duration open
    const value = typeAndDuration.get(ttl);

    if (value) {
      typeAndDuration.set(ttl, nonExitDuration);
    } else {
      typeAndDuration.set(ttl, "last 2 weeks");
      setIsEyeOpen(false);
      setSelectedRadio("on1");
      // onClickHandler("last 2 weeks");
    }
  };
  // Layer visibility button funtion
  const VisibilityButton = (ttl: string) => {
    setClickedPopup(true);
    setIsEyeOpen((prevState) => !prevState);
    setIncidentType(ttl);
    //to check open hazardtypes
    if (isEyeOpen) {
      openHzType(ttl, true);
    } else {
      openHzType(ttl, false);

      const mappedType = incidentTypeMap.get(ttl);
      if (mappedType) {
        removeOverlay(mappedType);
        setTimeout(() => {
          removeOverlay(mappedType);
        }, 500);
      }
    }
  };

  useEffect(() => {}, [typeAndDuration]);

  useEffect(() => {
    if (
      incidentType !== "" &&
      selectedDuration !== "" &&
      clickedPopup === true
    ) {
      if (!isEyeOpen) {
        onClickHandler(nonExitDuration);
      } else {
        onClickHandler("Clear");
      }
    } else if (
      incidentType !== "" &&
      selectedDuration === "" &&
      clickedPopup === true
    ) {
      if (!isEyeOpen) {
        onClickHandler("last 2 weeks");
      } else {
        onClickHandler("Clear");
      }
    }
  }, [isEyeOpen]);

  // Layer filter all button funtion
  const FilterAllButton = (
    title: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedRadio(event.target.value);
    HazardTypeDurationMap.set(title, event.target.value);
    if (event.target.value === "on4") {
      setIsAllFilterOpen(true);
    } else {
      setIsAllFilterOpen(false);
    }
  };

  const touchStartY = useRef(0);
  const touchMoveY = useRef(0);

  const handleDragStart = (
    e: React.DragEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
  ) => {
    dragItemRef.current = index;
    if ("clientY" in e) {
      touchStartY.current = e.clientY;
    } else if (e.touches && e.touches.length > 0) {
      touchStartY.current = e.touches[0].clientY;
    }
  };

  const handleDragEnter = (
    e: React.DragEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>
  ) => {
    dragOverRef.current = index;
    if ("clientY" in e) {
      touchMoveY.current = e.clientY;
    } else if (e.touches && e.touches.length > 0) {
      touchMoveY.current = e.touches[0].clientY;
    }
  };

  const handleDragEnd = () => {
    if (Math.abs(touchMoveY.current - touchStartY.current) > 10) {
      handleSort();
    }
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    handleDragStart(e);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    handleDragEnter(e);
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    handleDragEnd();
  };

  return (
    <div
      key={id}
      className={styles.layerItem}
      draggable={true}
      onDragStart={handleDragStart}
      onDragEnter={handleDragEnter}
      onDragEnd={handleDragEnd}
      onDragOver={(e) => e.preventDefault()}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div className={styles.header}>
        <div className={styles.headerCell} style={{ gridArea: `a` }}>
          <img
            src={require("../../assets/grid.png")}
            alt=""
            draggable={false}
            style={{ cursor: `move` }}
          />
        </div>
        <div
          id={title + "btn"}
          className={styles.headerCell}
          style={{ gridArea: `b` }}
          onClick={() => {
            VisibilityButton(title);
            if (!HazardTypeDurationMap.get(title)) {
              HazardTypeDurationMap.set(title, "last 2 weeks");
            }
          }}
          onTouchStart={() => {
            VisibilityButton(title);
            if (!HazardTypeDurationMap.get(title)) {
              HazardTypeDurationMap.set(title, "last 2 weeks");
            }
          }}
        >
          <img
            src={
              isEyeOpen
                ? require("../../assets/eye-close.png")
                : require("../../assets/eye-open.png")
            }
            alt=""
          />
        </div>
        <div className={styles.headerCell} style={{ gridArea: `c` }}>
          <img
            src={require("../../assets/clock2.png")}
            alt=""
            style={{ height: `55%` }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row", // Set default direction as row
            justifyContent: "flex-start", // Aligns content to the start of the main axis (row)
            alignItems: "center", // Centers content along the cross axis (column)
            fontSize: "0.8rem",
            width: "100%",
          }}
        >
          {title}
        </div>
        <div
          className={styles.headerCell}
          style={{ gridArea: `e` }}
          onClick={() => DropDownMenu(title)}
          onTouchStart={() => DropDownMenu(title)}
        >
          <img
            src={require("../../assets/info.png")}
            alt=""
            style={{ height: `60%` }}
          />
        </div>
        <div
          className={styles.headerCell}
          style={{ gridArea: `f` }}
          onClick={() => DropDownMenu(title)}
          onTouchStart={() => DropDownMenu(title)}
        >
          <img
            src={require("../../assets/setting.png")}
            alt=""
            style={{ height: `50%` }}
          />
        </div>
        <div className={styles.headerCell} style={{ gridArea: `g` }}>
          <img src={require("../../assets/close.png")} alt="" />
        </div>
      </div>
      <div
        className={styles.contentContainer}
        style={{ height: `${isOpen ? "40px" : "0"}` }}
      >
        <input
          type="radio"
          name={`timeFilter${title}`}
          id={`${title}${1}`}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            FilterAllButton(title, event)
          }
          value="on1"
          checked={selectedRadio === "on1"}
        />
        <label
          className={styles.filterLabel}
          htmlFor={`${title}${1}`}
          onClick={() => onClickHandler("last 2 weeks")}
          onTouchStart={() => onClickHandler("last 2 weeks")}
        >
          last 2 weeks
        </label>
        <input
          type="radio"
          name={`timeFilter${title}`}
          id={`${title}${2}`}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            FilterAllButton(title, event)
          }
          value="on2"
          checked={selectedRadio === "on2"}
        />
        <label
          className={styles.filterLabel}
          htmlFor={`${title}${2}`}
          onClick={() => {
            onClickHandler("last 1 month");
          }}
          onTouchStart={() => onClickHandler("last 1 month")}
        >
          last 1 month
        </label>

        <input
          type="radio"
          name={`timeFilter${title}`}
          id={`${title}${3}`}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            FilterAllButton(title, event)
          }
          value="on3"
          checked={selectedRadio === "on3"}
        />
        <label
          className={styles.filterLabel}
          htmlFor={`${title}${3}`}
          onClick={() => {
            onClickHandler("last 6 months");
          }}
          onTouchStart={() => onClickHandler("last 6 months")}
        >
          last 6 months
        </label>

        <input
          type="radio"
          name={`timeFilter${title}`}
          id={`${title}${4}`}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            FilterAllButton(title, event)
          }
          value="on4"
          checked={selectedRadio === "on4"}
        />
        <label
          className={styles.filterLabel}
          htmlFor={`${title}${4}`}
          onClick={() => onClickHandler("custom date")}
          onTouchStart={() => onClickHandler("custom date")}
        >
          custom date
        </label>
      </div>
      <TimelineTimeRangePopup
        passForm={passStartDurationForm}
        passTo={passFromDurationTo}
        showTimeRangeNotification={() => showTimeRangeNotification(true)}
        isAllFilterOpen={isAllFilterOpen}
        title={title}
      />
    </div>
  );
};
export default IncidentsMenuDropDown;
